import React from 'react';

/**
 * @param {number} starCount 
 */
const StarField = ({ starCount = 80 }) => {
  const stars = React.useMemo(() => {
    return Array.from({ length: starCount }, (_, i) => ({
      id: i,
      size: Math.random() > 0.7 ? 3 : Math.random() > 0.4 ? 2 : 1,
      left: Math.random() * 100,
      top: Math.random() * 100,
      animationType: ['twinkle', 'twinkle-slow', 'twinkle-fast'][
        Math.floor(Math.random() * 3)
      ],
      duration: 3 + Math.random() * 4,
      delay: Math.random() * 3,
      isOrange: Math.random() > 0.8,
    }));
  }, [starCount]);

  const shootingStars = React.useMemo(() => {
    return Array.from({ length: 6 }, (_, i) => ({
      id: `shooting-${i}`,
      left: Math.random() * 100,
      top: Math.random() * 60,
      delay: Math.random() * 20,
    }));
  }, []);

  return (
    <div 
      className="position-fixed top-0 start-0 bottom-0 end-0 overflow-hidden" 
      style={{ pointerEvents: 'none', zIndex: 0 }}
    >
      {stars.map((star) => (
        <div
          key={star.id}
          className="position-absolute rounded-circle"
          style={{
            width: `${star.size}px`,
            height: `${star.size}px`,
            left: `${star.left}%`,
            top: `${star.top}%`,
            backgroundColor: star.isOrange ? '#fa5c36' : 'white',
            animation: `${star.animationType} ${star.duration}s ease-in-out infinite`,
            animationDelay: `${star.delay}s`,
            boxShadow: star.isOrange
              ? '0 0 8px rgba(250,92,54,0.8), 0 0 4px rgba(250,92,54,1)'
              : '0 0 6px rgba(255,255,255,0.6), 0 0 3px rgba(255,255,255,0.8)',
          }}
        />
      ))}
      {shootingStars.map((shootingStar) => (
        <div
          key={shootingStar.id}
          className="position-absolute"
          style={{
            left: `${shootingStar.left}%`,
            top: `${shootingStar.top}%`,
            width: '2px',
            height: '2px',
            backgroundColor: '#fa5c36',
            borderRadius: '50%',
            boxShadow: '0 0 10px rgba(250,92,54,1), 0 0 20px rgba(250,92,54,0.8), 0 0 30px rgba(250,92,54,0.6)',
            animation: 'shooting-star 2.5s ease-out infinite',
            animationDelay: `${shootingStar.delay}s`,
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: '0',
              left: '0',
              width: '80px',
              height: '2px',
              background: 'linear-gradient(to left, rgba(250,92,54,1), transparent)',
              boxShadow: '0 0 6px rgba(250,92,54,0.8)',
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default StarField;
